import { render, staticRenderFns } from "./NewsScroll.vue?vue&type=template&id=dc82ca0a&"
import script from "./NewsScroll.vue?vue&type=script&lang=ts&"
export * from "./NewsScroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports